import { render, staticRenderFns } from "./muokkaa-suoritteen-kategoriaa.vue?vue&type=template&id=2c2dd6fa&scoped=true&"
import script from "./muokkaa-suoritteen-kategoriaa.vue?vue&type=script&lang=ts&"
export * from "./muokkaa-suoritteen-kategoriaa.vue?vue&type=script&lang=ts&"
import style0 from "./muokkaa-suoritteen-kategoriaa.vue?vue&type=style&index=0&id=2c2dd6fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2dd6fa",
  null
  
)

export default component.exports